'use strict';

angular.module('configuration',[])
   .constant('token_cookie_name', require('../../config').cookies.token_cookie_name)
   .constant('domain', '.exploros.com');

